import Model from "./abstract/Model";

export const ACCESSORY_TAG = {
  TOW_BAR: 'tow_bar',
  WINTER_TYRES: 'winter_tyres'
}

export default class Accessory extends Model {

  constructor(props) {
    super();

    this.initializeAttributes(props);
  }
}
